import { render, staticRenderFns } from "./LensOverviewCard.vue?vue&type=template&id=0522062d&scoped=true"
import script from "./LensOverviewCard.vue?vue&type=script&lang=js"
export * from "./LensOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./LensOverviewCard.vue?vue&type=style&index=0&id=0522062d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0522062d",
  null
  
)

export default component.exports